// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"8e198414","797":"23f6f0a6"}[chunkId] + ".chunk.js";
};